import app from 'flarum/forum/app';
import { override, extend } from 'flarum/common/extend';
import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';
import Discussion from 'flarum/common/models/Discussion';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import KapokLanding from './components/KapokLanding';
import HotDiscussions from './components/HotDiscussions';
import PollBox from './components/PollBox';

// Material star（精华标记）
const STAR_PATH = 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z';
app.initializers.add('kapok-plus-site', () => {
  // users.kapok_covenant_agreed_at → user.kapokCovenantAgreed()
  User.prototype.kapokCovenantAgreed = Model.attribute('kapokCovenantAgreed');
  // discussions.kapok_is_essence → discussion.kapokIsEssence()
  Discussion.prototype.kapokIsEssence = Model.attribute('kapokIsEssence');
  // users.kapok_is_faculty → user.kapokIsFaculty()
  User.prototype.kapokIsFaculty = Model.attribute('kapokIsFaculty');
  // users.kapok_points → user.kapokPoints()
  User.prototype.kapokPoints = Model.attribute('kapokPoints');

  // 移除中英文切换按钮（系统默认中文）
  extend('flarum/forum/components/HeaderSecondary', 'items', function (items) {
    if (items.has('locale')) items.remove('locale');
  });

  // 等级阈值（与后端 Points::THRESHOLDS 一致）
  const KAPOK_TH = [0, 50, 150, 300, 600, 1000, 1500, 2200, 3000, 4000];

  // 华工相关称号（Lv.1-10）
  const KAPOK_TITLES = ['木棉新芽', '华园萌新', '百步梯行者', '东湖常客', '图书馆之友', '华园骨干', '木棉精英', '华园元老', '木棉传奇', '华工之光'];
  const titleOf = p => KAPOK_TITLES[Math.min(levelOf(p), 10) - 1];

  // 等级 chip：Lv.N（积分等级）
  const levelOf = p => {
    let lv = 1;
    KAPOK_TH.forEach((t, i) => {
      if ((p || 0) >= t) lv = i + 1;
    });
    return Math.min(lv, 10);
  };

  // 「老师」标记通过标题旁 chips 展示（见下方 infoItems），避免头像角标重叠

  // 公约硬门槛：开机主动查询同意状态（不依赖用户资源属性序列化，最可靠）
  let gateNeeded = null; // null=未知 true=未同意 false=已同意

  function needsGate() {
    return gateNeeded === true;
  }
  function refreshGate() {
    const u = app.session && app.session.user;
    if (!u) {
      gateNeeded = false;
      return Promise.resolve();
    }
    return app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/kapok-covenant/agree`,
      deserialize: JSON.parse
    }).then(r => {
      gateNeeded = !(r && r.agreed);
    }).catch(() => {
      gateNeeded = false;
    });
  }

  // 公约硬门槛：用纯 DOM 全屏遮罩实现（不依赖 mithril 渲染/路由，任何页面都盖住）。
  // 试过 override(app,'view') 与客户端路由跳转，前者不生效、后者服务端 404，均不可靠。
  function showGateOverlay() {
    if (document.getElementById('kapok-gate')) return;
    const el = document.createElement('div');
    el.id = 'kapok-gate';
    el.className = 'KapokCovenantGate';
    el.innerHTML = '<div class="KapokCovenantGate-head"><h2>欢迎回家，华工人</h2>' + '<p>进入社区前，请先完整阅读并同意《华南木棉 Plus 社区公约》。不同意则无法进入社区。</p></div>' + '<div class="KapokCovenantGate-body">公约加载中…</div>' + '<div class="KapokCovenantGate-foot"><button class="Button Button--primary Button--block" data-gate-agree>我已阅读并同意《社区公约》</button></div>';
    document.body.appendChild(el);
    el.querySelector('[data-gate-agree]').addEventListener('click', () => {
      app.request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/kapok-covenant/agree`,
        deserialize: JSON.parse
      }).then(() => window.location.reload()).catch(() => {});
    });
    fetch('/covenant', {
      credentials: 'same-origin'
    }).then(r => r.text()).then(text => {
      const mm = text.match(/<main[^>]*>([\s\S]*?)<\/main>/i);
      el.querySelector('.KapokCovenantGate-body').innerHTML = mm ? mm[1] : text;
    }).catch(() => {});
  }
  refreshGate().then(() => {
    if (needsGate()) showGateOverlay();
    m.redraw();
  });

  // 看门狗：登录后若讨论列表 6s 仍在转圈（SPA 旧状态/竞态），自动整页刷新一次（每个标签页仅一次）
  setTimeout(() => {
    if (!app.session.user) return;
    if (sessionStorage.getItem('kapokWatchdog') === 'done') return;
    sessionStorage.setItem('kapokWatchdog', 'pending');
    setTimeout(() => {
      const stuck = document.querySelector('.DiscussionList .LoadingIndicator, .IndexPage .LoadingIndicator');
      const ok = document.querySelector('.DiscussionListItem');
      if (stuck && !ok) {
        sessionStorage.setItem('kapokWatchdog', 'done');
        window.location.reload();
      } else {
        sessionStorage.removeItem('kapokWatchdog');
      }
    }, 6000);
  }, 1000);
  // 游客访问首页时展示落地页（仿高校 BBS 首页）。
  // 注意：替换返回值必须用 override，extend 会忽略回调返回值。
  override(IndexPage.prototype, 'view', function (original) {
    if (app.session.user) return original();
    return m(KapokLanding, null);
  });

  // 会员首页侧栏：投票/热帖改用纯 DOM 注入（见 injectSidebarWidgets），
  // 不再作为 mithril 组件挂载（曾导致首帧 mount 崩溃、列表永远转圈）
  override(IndexPage.prototype, 'sidebar', function (original) {
    return original();
  });

  // 讨论页侧栏：投票也改纯 DOM 注入，不再挂 mithril 组件
  // （原 extend sidebarItems 挂 PollBox 已移除）

  // ===== 纯 DOM 侧栏挂件（投票 / 十大热帖），完全绕开 mithril 渲染 =====
  const mk = html => {
    const t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstChild;
  };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[c]);
  const sidebarAnchor = () => document.querySelector('.IndexPage-nav, .DiscussionPage-nav, .App-content .sideNav, .IndexPage .sideNav');
  const dropOld = id => {
    const old = document.getElementById(id);
    if (old) old.remove();
  };
  function renderPollCard(poll) {
    const voted = (poll.myVotes || []).length > 0;
    const opts = poll.options.map(o => {
      if (voted || poll.expired) {
        return `<div class="KapokPoll-bar"><div class="KapokPoll-barFill" style="width:${o.percent}%"></div><span class="KapokPoll-barText">${poll.myVotes.includes(o.id) ? '✓ ' : ''}${esc(o.text)} · ${o.percent}%</span></div>`;
      }
      return `<label class="KapokPoll-opt"><input type="${poll.multiple ? 'checkbox' : 'radio'}" name="kpoll-${poll.id}" value="${o.id}"><span>${esc(o.text)}</span></label>`;
    }).join('');
    const foot = voted || poll.expired ? `<span>${poll.totalVotes} 人参与</span><span class="KapokPoll-voted">已投</span>` : `<span>${poll.totalVotes} 人参与</span><button class="Button Button--primary Button--small" data-kpoll-vote="${poll.id}">投票</button>`;
    return mk(`<div class="KapokPoll" id="kpoll-${poll.id}"><div class="KapokPoll-item"><div class="KapokPoll-title">投票 · ${esc(poll.title)}${poll.expired ? ' <span class="KapokPoll-expired">已截止</span>' : ''}</div><div class="KapokPoll-options">${opts}</div><div class="KapokPoll-foot">${foot}</div></div></div>`);
  }
  function loadPolls(scope, discussionId, shell) {
    const slot = shell ? shell.querySelector('#kapok-poll-slot') : null;
    if (!slot) return;
    let q = `scope=${scope}`;
    if (scope === 'discussion' && discussionId) q += `&discussion_id=${discussionId}`;
    app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/kapok-polls?${q}`,
      deserialize: JSON.parse
    }).then(res => {
      (res && res.items || []).forEach(poll => {
        dropOld(`kpoll-${poll.id}`);
        const card = renderPollCard(poll);
        const btn = card.querySelector('[data-kpoll-vote]');
        if (btn) {
          btn.addEventListener('click', () => {
            const ids = Array.from(card.querySelectorAll(`input[name="kpoll-${poll.id}"]:checked`)).map(i => parseInt(i.value, 10));
            if (!ids.length) return;
            app.request({
              method: 'POST',
              url: `${app.forum.attribute('apiUrl')}/kapok-polls/${poll.id}/vote`,
              body: {
                option_ids: ids
              },
              deserialize: JSON.parse
            }).then(() => loadPolls(scope, discussionId, anchor)).catch(() => {});
          });
        }
        slot.appendChild(card);
      });
      if (shell) shell.dataset.pollDone = '1';
    }).catch(() => {});
  }
  function uuid() {
    return crypto.randomUUID && crypto.randomUUID() || 'k-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }
  function loadMe(shell) {
    const slot = shell ? shell.querySelector('#kapok-points-widget') : null;
    if (!slot) return;
    app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/kapok-me`,
      deserialize: JSON.parse
    }).then(me => {
      const lv = me.level;
      const prev = KAPOK_TH[lv - 1] ?? 0;
      const next = me.nextLevelPoints;
      const pct = next ? Math.min(100, Math.round((me.points - prev) / (next - prev) * 100)) : 100;
      slot.innerHTML = '<div class="KapokMe">' + '<div class="KapokMe-level">Lv.' + lv + '</div>' + '<div class="KapokMe-title">' + titleOf(me.points) + '</div>' + '<div class="KapokMe-points">积分 <b>' + me.points + '</b></div>' + '<div class="KapokBar"><div class="KapokBar-fill" style="width:' + pct + '%"></div></div>' + '<div class="KapokBar-label"><span>经验</span><span>' + (next ? me.points + ' / ' + next : 'MAX') + '</span></div>' + '<button class="Button Button--primary Button--block" id="kapok-signin-btn" ' + (me.signedToday ? 'disabled' : '') + '>' + (me.signedToday ? '今日已签到' : '签到 +5') + '</button>' + '<div class="KapokMe-storage">空间 ' + (me.storageUsed / 1048576).toFixed(1) + ' / 128 MB</div>' + '<div class="KapokBar"><div class="KapokBar-fill" style="width:' + Math.min(100, Math.round(me.storageUsed / me.storageQuota * 100)) + '%"></div></div>' + '</div>';
      slot.querySelector('#kapok-signin-btn').addEventListener('click', () => {
        app.request({
          method: 'POST',
          url: `${app.forum.attribute('apiUrl')}/kapok-signin`,
          deserialize: JSON.parse
        }).then(() => loadMe(shell)).catch(() => {});
      });
      if (shell) shell.dataset.meDone = '1';
    }).catch(() => {});
  }
  function loadHot(shell) {
    const slot = shell ? shell.querySelector('#kapok-hot-widget') : null;
    if (!slot) return;
    app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/kapok-hot-discussions`,
      deserialize: JSON.parse
    }).then(res => {
      const items = res && res.items || [];
      const list = items.length ? `<ol class="KapokHot-list">${items.map((d, i) => `<li class="KapokHot-item" title="${esc(d.tag ? d.tag.name : '')}"><span class="KapokHot-rank KapokHot-rank--${i < 3 ? 'top' : 'normal'}">${i + 1}</span><a class="KapokHot-link" href="/d/${d.id}-${esc(d.slug)}">${esc(d.title)}</a><span class="KapokHot-count">今日 ${d.repliesToday} 回复</span></li>`).join('')}</ol>` : '<div class="KapokHot-empty">今天还很安静，来发第一帖吧</div>';
      slot.innerHTML = `<div class="KapokHot"><h3 class="KapokHot-title">十大热帖</h3>${list}</div>`;
      if (shell) shell.dataset.hotDone = '1';
    }).catch(() => {});
  }
  function loadOnline(shell) {
    const slot = shell ? shell.querySelector('#kapok-online-widget') : null;
    if (!slot) return;
    app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/kapok-online`,
      deserialize: JSON.parse
    }).then(res => {
      const users = res && res.users || [];
      const avatars = users.map(u => `<a class="KapokOnline-user" href="/u/${esc(u.username)}" title="${esc(u.displayName || u.username)}">${u.avatarUrl ? `<img src="${esc(u.avatarUrl)}" alt="">` : `<span class="KapokOnline-avatar-fallback">${esc((u.displayName || u.username || '?').slice(0, 1))}</span>`}</a>`).join('');
      slot.innerHTML = `<div class="KapokOnline"><div class="KapokOnline-head"><span class="KapokOnline-dot"></span>在线 ${res.count || 0} 人</div><div class="KapokOnline-users">${avatars || '<span class="KapokOnline-empty">现在只有你</span>'}</div></div>`;
      if (shell) shell.dataset.onlineDone = '1';
    }).catch(() => {});
  }

  // 侧栏稳定容器：热帖 / 投票 / 在线 按固定顺序各占一个槽位，动画只在容器首次创建时播一次
  // prepend=true 时插到锚点内部最前（用于帖子页：投票面板放到左侧内容区顶部）
  function ensureShell(anchor, mode, prepend) {
    let shell = document.getElementById('kapok-side-widgets');
    if (shell && shell.dataset.mode !== mode) {
      shell.remove();
      shell = null;
    }
    if (!shell) {
      shell = mk('<div id="kapok-side-widgets" class="KapokSideWidgets"><div id="kapok-points-widget"></div><div id="kapok-hot-widget"></div><div id="kapok-poll-slot"></div><div id="kapok-online-widget"></div></div>');
      shell.dataset.mode = mode;
      if (anchor && anchor.parentElement) {
        if (prepend) anchor.insertBefore(shell, anchor.firstChild);else if (mode === 'index') anchor.appendChild(shell); // 首页：作为右栏最后子元素（配合 grid 双栏）
        else anchor.parentElement.insertBefore(shell, anchor.nextSibling);
      }
    }
    if (mode === 'discussion') {
      shell.querySelector('#kapok-hot-widget').style.display = 'none';
      shell.querySelector('#kapok-online-widget').style.display = 'none';
    }
    return shell;
  }

  // 「添加投票」按钮（仅讨论作者可见，后端二次校验）+ 纯 DOM 表单
  function injectAddPollButton(discId, shell) {
    if (shell.dataset.addbtn === '1') return;
    shell.dataset.addbtn = '1';

    // 已有投票时不显示按钮
    const slot = shell.querySelector('#kapok-poll-slot');
    if (slot && slot.querySelector('.KapokPoll')) return;
    app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/discussions/${discId}`,
      deserialize: JSON.parse
    }).then(res => {
      const authorId = res && res.data && res.data.relationships && res.data.relationships.user && res.data.relationships.user.data ? res.data.relationships.user.data.id : null;
      const me = app.session && app.session.user && app.session.user.id();
      if (!me || String(authorId) !== String(me)) return;
      const btn = mk('<button id="kapok-addpoll-btn" class="Button Button--primary Button--block">为本帖添加投票</button>');
      btn.addEventListener('click', () => openPollForm(discId, shell));
      shell.appendChild(btn);
    }).catch(() => {});
  }
  function openPollForm(discId, shell) {
    if (document.getElementById('kapok-poll-form')) return;
    const el = mk('<div id="kapok-poll-form" class="KapokPollForm"><div class="KapokPollForm-box"><h3>为本帖添加投票</h3>' + '<label>投票标题<input id="kpf-title" type="text" placeholder="例如：周末去哪玩？"></label>' + '<label>选项（每行一个，至少两个）<textarea id="kpf-options" rows="5"></textarea></label>' + '<label class="KapokPollForm-check"><input id="kpf-multi" type="checkbox"> 允许多选</label>' + '<div class="KapokPollForm-actions"><button class="Button" id="kpf-cancel">取消</button><button class="Button Button--primary" id="kpf-submit">发布投票</button></div>' + '<p class="KapokPollForm-msg"></p></div></div>');
    document.body.appendChild(el);
    el.querySelector('#kpf-cancel').addEventListener('click', () => el.remove());
    el.querySelector('#kpf-submit').addEventListener('click', () => {
      const title = el.querySelector('#kpf-title').value.trim();
      const options = el.querySelector('#kpf-options').value.split('\n').map(s => s.trim()).filter(Boolean);
      const msg = el.querySelector('.KapokPollForm-msg');
      if (!title || options.length < 2) {
        msg.textContent = '请填写标题，并提供至少两个选项。';
        return;
      }
      msg.textContent = '发布中…';
      app.request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/kapok-polls`,
        body: {
          scope: 'discussion',
          discussion_id: parseInt(discId, 10),
          title,
          options,
          multiple: el.querySelector('#kpf-multi').checked
        },
        deserialize: JSON.parse
      }).then(() => {
        el.remove();
        shell.dataset.pollDone = '';
        loadPolls('discussion', discId, shell);
      }).catch(e => {
        msg.textContent = '发布失败：' + String(e && e.message || '');
      });
    });
  }

  // 定时补注入：mithril redraw 会移除我们插入侧栏的节点，故缺失时重建容器并拉数据
  // 资料页：任意用户 hero 区显示 等级/经验
  function ensureHeroLevel() {
    const m = location.pathname.match(/^\/u\/([^/]+)$/);
    if (!m) return;
    const hero = document.querySelector('.UserPage .Page-hero .UserHero') || document.querySelector('.Page-hero');
    if (!hero || document.getElementById('kapok-hero-level')) return;
    const uname = decodeURIComponent(m[1]);
    app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/users?filter[q]=${encodeURIComponent(uname)}`,
      deserialize: JSON.parse
    }).then(res => {
      const d = (res.data || []).find(u => u.attributes.username.toLowerCase() === uname.toLowerCase());
      if (!d) return;
      const pts = d.attributes.kapokPoints || 0;
      const el = mk(`<div id="kapok-hero-level" class="KapokHeroLevel">Lv.${levelOf(pts)} ${titleOf(pts)} · 经验 ${pts}</div>`);
      (hero.querySelector('.UserHero') || hero).appendChild(el);
    }).catch(() => {});
  }
  function ensureWidgets() {
    ensureHeroLevel();
    if (!app.session.user) return;
    const a = sidebarAnchor();
    if (!a) return;
    const onIndex = !!document.querySelector('.IndexPage');
    const discMatch = location.pathname.match(/^\/d\/(\d+)/);
    if (onIndex) {
      const pc = document.querySelector('.IndexPage .Page-content');
      if (!pc) return;
      const shell = ensureShell(pc, 'index');
      if (!shell.dataset.meDone) loadMe(shell);
      if (!shell.dataset.hotDone) loadHot(shell);
      if (!shell.dataset.pollDone) loadPolls('site', null, shell);
      if (!shell.dataset.onlineDone) loadOnline(shell);
    } else if (discMatch) {
      // 投票面板放帖子流内、正文之前（蓝色横幅下方）
      const stream = document.querySelector('.DiscussionPage-stream') || document.querySelector('.DiscussionPage .container');
      if (!stream) return;
      const shell = ensureShell(stream, 'discussion', true);
      if (!shell.dataset.pollDone) loadPolls('discussion', discMatch[1], shell);
      injectAddPollButton(discMatch[1], shell);
    }
  }

  // 提前触发两次，减少「等一会儿才出现」
  setTimeout(ensureWidgets, 250);
  setTimeout(ensureWidgets, 900);
  setInterval(ensureWidgets, 2000);

  // 在线名单每 60s 刷新一次
  setInterval(() => {
    const shell = document.getElementById('kapok-side-widgets');
    if (shell && shell.dataset.mode === 'index') loadOnline(shell);
  }, 60000);

  // ===== 发帖/回复幂等：由后端按「用户+标题+内容」60 秒窗口去重，前端无需传键 =====

  // ===== 应急模式横幅（管理员后台一键开启后全站提示） =====
  if (app.forum.attribute('kapokEmergency') === '1' || app.forum.attribute('kapokEmergency') === true) {
    const em = mk('<div style="position:fixed;top:0;left:0;right:0;z-index:2000;background:#c0392b;color:#fff;text-align:center;padding:8px 12px;font-size:14px">' + '系统维护中：发言与注册已临时关闭，浏览不受影响。' + '</div>');
    document.body.appendChild(em);
    document.documentElement.style.paddingTop = '36px';
  }

  // ===== 网盘下载链接：capture 阶段拦截点击，绕过 SPA 路由（否则 m.route.set 到
  // /api/... 无路由会回退主页），改用带 download 属性的临时锚点触发浏览器下载 =====
  document.addEventListener('click', e => {
    if (e.button !== 0 || e.defaultPrevented) return;
    const link = e.target && e.target.closest ? e.target.closest('a[href*="/kapok-files/"][href*="download"]') : null;
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    const a = mk(`<a href="${link.getAttribute('href')}" download></a>`);
    document.body.appendChild(a);
    a.click();
    a.remove();
  }, true);

  // ===== 编辑器图片上传：document 级委托（paste/drop 不依赖编辑器生命周期）+ 工具栏按钮 =====
  let kapokLastTa = null;
  document.addEventListener('focusin', e => {
    if (e.target && e.target.matches && e.target.matches('textarea')) kapokLastTa = e.target;
  });
  function kapokInsert(text) {
    const ta = kapokLastTa || document.querySelector('.Composer textarea');
    if (!ta) return;
    const pos = ta.selectionStart || ta.value.length;
    ta.setRangeText(text, pos, ta.selectionEnd || pos, 'end');
    ta.dispatchEvent(new Event('input', {
      bubbles: true
    }));
  }
  function kapokXhrUpload(fd, onProgress) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${app.forum.attribute('apiUrl')}/kapok-upload`);
      xhr.setRequestHeader('X-CSRF-Token', app.session.csrfToken);
      xhr.responseType = 'json';
      xhr.upload.onprogress = e => {
        if (e.lengthComputable && onProgress) onProgress(Math.round(e.loaded / e.total * 100));
      };
      xhr.onload = () => {
        const res = xhr.response || {};
        if (xhr.status >= 200 && xhr.status < 300 && res.id) {
          resolve(res);
        } else {
          const msg = res.errors && res.errors[0] && res.errors[0].detail || '上传失败';
          app.alerts.show({
            type: 'error'
          }, msg);
          reject(new Error(msg));
        }
      };
      xhr.onerror = () => {
        app.alerts.show({
          type: 'error'
        }, '上传失败');
        reject(new Error('网络错误'));
      };
      xhr.send(fd);
    });
  }
  function kapokUpload(file, onProgress) {
    const isImage = /^image\//.test(file.type);
    const fd = new FormData();
    fd.append('kind', isImage ? 'image' : 'file');
    fd.append('name', file.name || (isImage ? 'paste.png' : 'file'));
    if (isImage) fd.append('file', file);else fd.append('file', file, file.name || 'file');
    return kapokXhrUpload(fd, onProgress);
  }

  // composer 内统一入口：条内显示上传中百分比，完成替换为缩略图/文件 chip
  function composerUploadFile(file) {
    const item = {
      pending: true,
      name: file.name,
      pct: 0,
      kind: /^image\//.test(file.type) ? 'image' : 'file'
    };
    kapokUploads.push(item);
    renderStrip();
    kapokUpload(file, pct => {
      item.pct = pct;
      renderStrip();
    }).then(res => {
      const md = res.markdown || `[${res.name}](/api/kapok-files/${res.id}/download)`;
      Object.assign(item, {
        pending: false,
        md,
        fileId: res.id,
        kind: res.kind,
        url: res.url || null
      });
      kapokInsert('\n' + md + '\n');
      renderStrip();
    }).catch(() => {
      const i = kapokUploads.indexOf(item);
      if (i > -1) kapokUploads.splice(i, 1);
      renderStrip();
    });
  }
  document.addEventListener('paste', e => {
    const t = e.target;
    if (!t || !t.matches || !t.matches('textarea')) return;
    const items = e.clipboardData && e.clipboardData.items || [];
    for (const it of items) {
      if (it.kind !== 'file') continue;
      const f = it.getAsFile();
      if (f) {
        e.preventDefault();
        composerUploadFile(f);
      }
      break;
    }
  });
  document.addEventListener('dragover', e => {
    if (e.target && e.target.matches && e.target.matches('.Composer textarea')) e.preventDefault();
  });
  document.addEventListener('drop', e => {
    const t = e.target;
    if (!t || !t.matches || !t.matches('.Composer textarea')) return;
    const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0] || null;
    if (f) {
      e.preventDefault();
      composerUploadFile(f);
    }
  });

  // 上传条：实时预览本次粘贴/上传的图片与文件，可单独移除
  const kapokUploads = [];
  function renderStrip() {
    // 挂在编辑器容器内部（输入框内、textarea 下方）：该容器子树不受 mithril
    // 重渲染影响，粘贴后立即可见；提交按钮在容器外，不会被遮挡
    const te = document.querySelector('.Composer .TextEditor');
    let strip = document.getElementById('kapok-upload-strip');
    if (!te) {
      if (strip) strip.remove();
      return;
    }
    if (!strip) {
      strip = mk('<div id="kapok-upload-strip" class="KapokStrip"></div>');
      const container = te.querySelector('.TextEditor-editorContainer');
      if (container) container.appendChild(strip);else te.appendChild(strip);
    }
    strip.innerHTML = kapokUploads.length ? kapokUploads.map((u, i) => {
      if (u.pending) {
        return `<span class="KapokStrip-item KapokStrip-pending" data-i="${i}">` + `<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" style="color:#16a085"><path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"/></svg>` + `<span class="KapokStrip-pct">${u.pct || 0}%</span></span>`;
      }
      return `<span class="KapokStrip-item" data-i="${i}" title="${esc(u.name || '')}">` + (u.kind === 'image' && u.url ? `<img src="${u.url}">` : `<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" style="color:#16a085"><path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"/></svg>`) + `<button class="KapokStrip-x" data-x="${i}" type="button">×</button></span>`;
    }).join('') : '';
    strip.querySelectorAll('[data-x]').forEach(b => b.addEventListener('click', () => {
      const i = parseInt(b.dataset.x, 10);
      const u = kapokUploads[i];
      if (u) {
        const ta = document.querySelector('.Composer textarea');
        if (ta && ta.value.includes(u.md)) {
          ta.value = ta.value.replace(u.md, '');
          ta.dispatchEvent(new Event('input', {
            bubbles: true
          }));
        }
        if (u.fileId) {
          fetch(`/api/kapok-files/${u.fileId}`, {
            method: 'DELETE',
            credentials: 'same-origin',
            headers: {
              'X-CSRF-Token': app.session.csrfToken
            }
          });
        }
      }
      kapokUploads.splice(i, 1);
      renderStrip();
    }));
  }

  // Material 风格图标
  const MD_IMAGE = 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z';
  const MD_FILE = 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z';
  const svgBtn = (path, title, id) => mk(`<button id="${id}" class="Button Button--icon kapok-upload-btn" title="${title}" type="button">` + `<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="${path}"/></svg></button>`);

  // 工具栏注入：合并为一个「上传图片」+ 一个「上传文件」（Material 图标）；隐藏核心的纯语法图片按钮
  let kapokUploadInputImg = null;
  let kapokUploadInputFile = null;
  setInterval(() => {
    if (kapokUploads.length && document.querySelector('.Composer') && !document.getElementById('kapok-upload-strip')) {
      renderStrip();
    }
    const controls = document.querySelector('.TextEditor-controls');
    if (!controls) return;

    // 隐藏核心 markdown 的「插入图片」语法按钮（保留我们的上传按钮）
    controls.querySelectorAll('button').forEach(b => {
      const icon = b.querySelector('i,svg');
      const iconClass = icon ? icon.className.toString() : '';
      const isCoreImage = /fa-image/.test(iconClass) || /插入图片|insert image/i.test(b.title || '');
      if (isCoreImage && !b.classList.contains('kapok-upload-btn')) b.style.display = 'none';
    });
    if (!kapokUploadInputImg) {
      kapokUploadInputImg = mk('<input type="file" accept="image/*" hidden>');
      kapokUploadInputImg.addEventListener('change', () => {
        const f = kapokUploadInputImg.files[0];
        if (f) composerUploadFile(f);
        kapokUploadInputImg.value = '';
      });
      document.body.appendChild(kapokUploadInputImg);
    }
    if (!kapokUploadInputFile) {
      kapokUploadInputFile = mk('<input type="file" hidden>');
      kapokUploadInputFile.addEventListener('change', () => {
        const f = kapokUploadInputFile.files[0];
        if (f) composerUploadFile(f);
        kapokUploadInputFile.value = '';
      });
      document.body.appendChild(kapokUploadInputFile);
    }
    if (!document.getElementById('kapok-upload-img-btn')) {
      const b = svgBtn(MD_IMAGE, '上传图片', 'kapok-upload-img-btn');
      b.addEventListener('click', () => kapokUploadInputImg.click());
      controls.appendChild(b);
    }
    if (!document.getElementById('kapok-upload-file-btn')) {
      const b = svgBtn(MD_FILE, '上传文件', 'kapok-upload-file-btn');
      b.addEventListener('click', () => kapokUploadInputFile.click());
      controls.appendChild(b);
    }
    if (!document.getElementById('kapok-myfiles-btn')) {
      const b = svgBtn(MD_FOLDER, '从我的空间插入', 'kapok-myfiles-btn');
      b.addEventListener('click', () => {
        const dm = location.pathname.match(/^\/d\/(\d+)/);
        openMyFilesPanel(dm ? dm[1] : null);
      });
      controls.appendChild(b);
    }
  }, 1000);
  const MD_FOLDER = 'M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm6 16H4V8h16v12zM14 15c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z';
  function openMyFilesPanel(discId) {
    if (document.getElementById('kapok-files-panel')) return;
    const el = mk('<div id="kapok-files-panel" class="KapokFilesPanel"><div class="KapokFilesPanel-box"><h3>从我的空间插入</h3>' + '<div class="KapokFilesPanel-list" id="kapok-myfiles-list">加载中…</div>' + '<div class="KapokFilesPanel-actions"><button class="Button" id="kapok-myfiles-close">关闭</button></div></div></div>');
    document.body.appendChild(el);
    el.querySelector('#kapok-myfiles-close').addEventListener('click', () => el.remove());
    app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/kapok-me`,
      deserialize: JSON.parse
    }).then(me => {
      const list = el.querySelector('#kapok-myfiles-list');
      const files = me.files || [];
      list.innerHTML = files.length ? files.map(f => {
        const lvlSel = f.kind === 'file' && discId ? `<select class="FormControl KapokFilesPanel-lvl" data-lvl="${f.id}"><option value="0">Lv.0+</option><option value="3">Lv.3+</option><option value="5">Lv.5+</option><option value="8">Lv.8+</option></select>` : '';
        return `<div class="KapokFilesPanel-row" data-fid="${f.id}">` + `<span class="KapokChip ${f.kind === 'image' ? 'KapokChip--invited' : 'KapokChip--level'}">${f.kind === 'image' ? '图片' : '文件'}</span>` + `<span class="KapokFilesPanel-name">${esc(f.name)}</span>${lvlSel}` + `<button class="Button Button--primary Button--small" data-ins="${f.id}">插入</button></div>`;
      }).join('') : '空间里还没有文件';
      list.querySelectorAll('[data-ins]').forEach(b => {
        b.addEventListener('click', () => {
          const row = b.closest('.KapokFilesPanel-row');
          const fid = parseInt(b.dataset.ins, 10);
          const f = files.find(x => x.id === fid);
          if (!f) return;
          let md;
          if (f.kind === 'image') {
            md = `![${f.name}](${f.url})`;
          } else {
            const lvlSel = row.querySelector('[data-lvl]');
            const lvl = lvlSel ? parseInt(lvlSel.value, 10) : f.minLevel || 0;
            const doInsert = () => {
              md = discId ? `[${f.name}](/api/kapok-files/${fid}/download?d=${discId})` : `[${f.name}](/api/kapok-files/${fid}/download)`;
              kapokInsert('\n' + md + '\n');
              el.remove();
            };
            if (discId) {
              app.request({
                method: 'POST',
                url: `${app.forum.attribute('apiUrl')}/kapok-files/${fid}/shares`,
                body: {
                  discussion_id: parseInt(discId, 10),
                  min_level: lvl
                },
                deserialize: JSON.parse
              }).then(doInsert).catch(e => alert(String(e && e.message || '设置失败')));
            } else {
              doInsert();
            }
            return;
          }
          kapokInsert('\n' + md + '\n');
          el.remove();
        });
      });
    }).catch(() => {});
  }

  // ===== 个人空间（本人资料页顶部注入）：上传/列表/下载/删除 + 邀请码 =====
  let spaceData = null;
  function ensureSpace() {
    const me = app.session && app.session.user;
    const m = location.pathname.match(/^\/u\/([^/]+)$/);
    if (!me || !m || decodeURIComponent(m[1]).toLowerCase() !== me.username().toLowerCase()) {
      return;
    }

    // Flarum 2 资料页结构：.UserPage > .Page-container > .Page-content（主列）
    const host = document.querySelector('.UserPage .Page-content') || document.querySelector('.UserPage .Page-container') || document.querySelector('.UserPage-content .container');
    if (!host) return;
    let card = document.getElementById('kapok-space');
    if (card) return;
    card = mk('<div id="kapok-space" class="KapokSpace"><div class="KapokSpace-head"><b>个人空间</b>' + '<span id="kapok-space-usage"></span></div>' + '<div class="KapokSpace-bar" id="kapok-space-bar"></div>' + '<div class="KapokSpace-actions">' + '<label class="Button Button--primary Button--small">上传文件（≤20MB）<input id="kapok-space-file" type="file" hidden></label>' + '<select id="kapok-space-level" class="FormControl KapokSpace-level">' + '<option value="0">下载：不限等级</option><option value="3">下载：Lv.3+</option><option value="5">下载：Lv.5+</option><option value="8">下载：Lv.8+</option>' + '</select>' + '<button class="Button Button--small" id="kapok-space-invite">生成邀请码（+50/人）</button>' + '</div><div id="kapok-space-msg" class="KapokSpace-msg"></div>' + '<ul class="KapokSpace-files" id="kapok-space-files"></ul>' + '<div class="KapokSpace-invhead"><b>我的邀请码</b><span>被邀请人注册成功后你 +50 积分</span></div>' + '<ul class="KapokSpace-invites" id="kapok-space-invites"></ul></div>');
    host.insertBefore(card, host.firstChild);
    const fileInput = card.querySelector('#kapok-space-file');
    const levelSel = card.querySelector('#kapok-space-level');
    const msg = card.querySelector('#kapok-space-msg');
    fileInput.addEventListener('change', () => {
      const f = fileInput.files[0];
      if (!f) return;
      const fd = new FormData();
      fd.append('kind', 'file');
      fd.append('name', f.name);
      fd.append('min_level', levelSel.value);
      fd.append('file', f);
      const showPct = pct => {
        msg.innerHTML = '<div class="KapokBar"><div class="KapokBar-fill" style="width:' + pct + '%"></div></div>' + '<div class="KapokBar-label"><span>上传中 ' + pct + '%</span><span>' + (f.size / 1048576).toFixed(1) + ' MB</span></div>';
      };
      showPct(0);
      kapokXhrUpload(fd, showPct).then(res => {
        msg.textContent = '上传成功：' + res.name;
        fileInput.value = '';
        refreshSpace();
      }).catch(() => msg.textContent = '上传失败');
    });
    card.querySelector('#kapok-space-invite').addEventListener('click', () => {
      app.request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/kapok-invite`,
        deserialize: JSON.parse
      }).then(res => {
        msg.textContent = '新邀请码（3天内有效，仅限本校邮箱注册）：' + res.code;
      }).catch(e => {
        msg.textContent = String(e && e.message || '生成失败');
      });
    });
    refreshSpace();
  }
  function refreshSpace() {
    app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/kapok-me`,
      deserialize: JSON.parse
    }).then(me => {
      spaceData = me;
      const usage = document.querySelector('#kapok-space-usage');
      const bar = document.getElementById('kapok-space-bar');
      const pct = Math.min(100, Math.round(me.storageUsed / me.storageQuota * 100));
      if (usage) usage.textContent = `${pct}%`;
      if (bar) {
        bar.innerHTML = '<div class="KapokBar"><div class="KapokBar-fill" style="width:' + pct + '%"></div></div>' + '<div class="KapokBar-label"><span>已用 ' + (me.storageUsed / 1048576).toFixed(1) + ' MB</span><span>128 MB</span></div>';
      }
      const ul = document.querySelector('#kapok-space-files');
      if (!ul) return;
      ul.innerHTML = (me.files || []).length ? me.files.map(f => `<li><span class="KapokChip ${f.kind === 'image' ? 'KapokChip--invited' : 'KapokChip--level'}">${f.kind === 'image' ? '图片' : '文件'}</span><span class="KapokSpace-name">${esc(f.name)}</span><span class="KapokSpace-size">${(f.size / 1024).toFixed(0)}KB</span>` + `<span class="KapokSpace-meta">${f.kind === 'image' ? '查看无限制' : '下载需 Lv.' + f.minLevel}</span>` + (f.url ? `<a class="Button Button--small" href="${f.url}" target="_blank">查看</a>` : `<a class="Button Button--small" href="/api/kapok-files/${f.id}/download">下载</a>`) + `<button class="Button Button--danger Button--small" data-del="${f.id}">删除</button></li>`).join('') : '<li>还没有文件</li>';
      ul.querySelectorAll('[data-del]').forEach(b => b.addEventListener('click', () => {
        fetch(`${app.forum.attribute('apiUrl')}/kapok-files/${b.dataset.del}`, {
          method: 'DELETE',
          credentials: 'same-origin',
          headers: {
            'X-CSRF-Token': app.session.csrfToken
          }
        }).then(() => refreshSpace()).catch(() => {});
      }));

      // 我的邀请码：列表 + 注销
      const invUl = document.getElementById('kapok-space-invites');
      if (invUl) {
        app.request({
          method: 'GET',
          url: `${app.forum.attribute('apiUrl')}/kapok-invite`,
          deserialize: JSON.parse
        }).then(res => {
          const codes = res && res.items || [];
          invUl.innerHTML = codes.length ? codes.map(c => {
            const expired = c.expiresAt && new Date(c.expiresAt) < new Date();
            const status = c.status === 'used' ? '已使用' : c.status === 'revoked' ? '已注销' : expired ? '已过期' : '未使用';
            const chip = c.status === 'unused' && !expired ? 'KapokChip--invited' : 'KapokChip--admin';
            return `<li><code>${esc(c.code)}</code><span class="KapokChip ${chip}">${status}</span>` + `<span class="KapokSpace-meta">${c.usedBy ? '绑定：' + esc(c.usedBy) : '未绑定'} · 有效期至 ${c.expiresAt ? c.expiresAt.slice(0, 10) : ''}</span>` + (c.revocable ? `<button class="Button Button--danger Button--small" data-revoke="${c.id}">注销</button>` : '') + `</li>`;
          }).join('') : '<li>还没有生成过邀请码</li>';
          invUl.querySelectorAll('[data-revoke]').forEach(b => b.addEventListener('click', () => {
            if (!confirm('确定注销该邀请码？注销后不可恢复。')) return;
            app.request({
              method: 'POST',
              url: `${app.forum.attribute('apiUrl')}/kapok-invite`,
              body: {
                action: 'revoke',
                id: parseInt(b.dataset.revoke, 10)
              },
              deserialize: JSON.parse
            }).then(() => refreshSpace()).catch(e => alert(String(e && e.message || '失败')));
          }));
        }).catch(() => {});
      }
    }).catch(() => {});
  }
  setInterval(ensureSpace, 2000);

  // 讨论列表条目：作者身份 chips（站长/老师/邀请用户）+ 精华星标
  extend('flarum/forum/components/DiscussionListItem', 'infoItems', function (items) {
    const author = this.attrs.discussion && this.attrs.discussion.user();
    if (author) {
      const pts = author.kapokPoints ? author.kapokPoints() : 0;
      if (pts != null) {
        items.add('kapokLevelChip', m("span", {
          className: "KapokChip KapokChip--level"
        }, "Lv.", levelOf(pts)), 21);
      }
      if (author.isAdmin && author.isAdmin()) {
        items.add('kapokAdminChip', m("span", {
          className: "KapokChip KapokChip--admin"
        }, "\u7AD9\u957F"), 20);
      }
      if (author.kapokIsFaculty && author.kapokIsFaculty()) {
        items.add('kapokFacultyChip', m("span", {
          className: "KapokChip KapokChip--faculty"
        }, "\u8001\u5E08"), 19);
      }
      if (author.kapokIsInvited && author.kapokIsInvited()) {
        items.add('kapokInvitedChip', m("span", {
          className: "KapokChip KapokChip--invited"
        }, "\u9080\u8BF7\u7528\u6237"), 18);
      }
    }
    if (this.attrs.discussion && this.attrs.discussion.kapokIsEssence && this.attrs.discussion.kapokIsEssence()) {
      items.add('kapokEssence', m("span", {
        className: "KapokEssence",
        title: "\u7CBE\u534E"
      }, m("svg", {
        className: "MaterialIcon",
        viewBox: "0 0 24 24",
        width: "1em",
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true"
      }, m("path", {
        d: STAR_PATH
      })), "\u7CBE\u534E"), 5);
    }
  });

  // 管理菜单：设为/取消精华（仅管理员；内容审核员/版主可走 API 权限）
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (!app.session.user || !app.session.user.isAdmin()) return;
    const on = !!(discussion.kapokIsEssence && discussion.kapokIsEssence());
    items.add('kapokEssence', m(Button, {
      icon: on ? 'fas fa-star' : 'far fa-star',
      onclick: () => {
        app.request({
          method: 'POST',
          url: `${app.forum.attribute('apiUrl')}/kapok-discussions/${discussion.id()}/essence`,
          body: {
            on: !on
          },
          deserialize: JSON.parse
        }).then(() => {
          discussion.pushAttributes({
            kapokIsEssence: !on
          });
          m.redraw();
        }).catch(() => {});
      }
    }, on ? '取消精华' : '设为精华'), 95);
  });
});